import { forwardRef, ReactNode } from 'react';
import { cx } from '../../../utils/cx';
import { NumberField, NumberFieldProps, Group } from 'react-aria-components';
import { Label } from './label';
import { InputBase } from './input';
import { HintText } from './hint-text';

interface NumberInputProps extends NumberFieldProps {
  label?: string;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  isRequired?: boolean;
  hideRequiredIndicator?: boolean;
  hint?: ReactNode;
  tooltip?: string;
}

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  (
    {
      label,
      placeholder,
      isRequired,
      hideRequiredIndicator,
      className,
      labelClassName,
      hint,
      tooltip,
      isInvalid,
      ...props
    }: NumberInputProps,
    ref
  ) => {
    return (
      <NumberField
        {...props}
        isInvalid={isInvalid}
        aria-label={label ? placeholder : undefined}
        className={cx('flex flex-col gap-1.5', className)}
      >
        {label && (
          <Label
            isRequired={
              hideRequiredIndicator ? !hideRequiredIndicator : isRequired
            }
            className={labelClassName}
          >
            {label}
          </Label>
        )}
        <Group>
          <InputBase type="number" ref={ref} {...(tooltip && { tooltip })} />
        </Group>
        {hint && <HintText isInvalid={isInvalid}>{hint}</HintText>}
      </NumberField>
    );
  }
);

NumberInput.displayName = 'NumberInput';
